import { logoBase64 } from "@/assets/logoBase64";
import { env } from "@/env";
import { PageLoader } from "@/shared/components/PageLoader/PageLoader";
import { CACHE_VERSION } from "@/shared/constants/CACHE_VERSION";
import { useNetworkStatus } from "@/shared/hooks/useNetworkStatus";
import { LoginOutlined } from "@ant-design/icons";
import { App, Button, Typography } from "antd";
import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Navigate, useNavigate } from "react-router";
import styles from "./style.module.css";

export function Login() {
  const { isOnline } = useNetworkStatus();
  const navigate = useNavigate();
  const { user, signinRedirect, isLoading, isAuthenticated } = useAuth();
  const { notification } = App.useApp();

  const handleLogin = async () => {
    if (user && isAuthenticated) {
      navigate("/inicio");
      return;
    }

    if (!isOnline) {
      notification.error({
        message: "Não é possível realizar o login enquanto estiver offline.",
        description: "Conecte-se à internet e tente novamente.",
      });
      return;
    }

    await signinRedirect();
  };

  useEffect(() => {
    document.title = "Inspeção Mobile - Login";
  }, []);

  if (isLoading) {
    return <PageLoader />;
  }

  if (user && isAuthenticated) {
    return <Navigate to="/inicio" replace />;
  }

  return (
    <>
      <div className={styles["login-panel"]}>
        <div className={styles["login-form"]}>
          <Typography className={styles["titulo-sisdev"]}>
            Inspeção Mobile
          </Typography>

          <img src={logoBase64} alt="Logo" className={styles["login-logo"]} />

          <Button type="primary" onClick={handleLogin} icon={<LoginOutlined />}>
            Entrar
          </Button>
        </div>
      </div>
      <div
        className={`${styles["container-cache-version"]} ${
          env.REACT_APP_AMBIENTE
            ? styles["container-cache-version-ambiente"]
            : ""
        }`}
      >
        {`${env.REACT_APP_AMBIENTE} ${CACHE_VERSION}`.trim()}
      </div>
    </>
  );
}
